import { supabase } from "@/integrations/supabase/client";

const THROTTLE_MS = 30 * 60 * 1000; // 30 minutes
const STORAGE_KEY = "presence:lastRunAt";
let firedThisLoad = false;

/**
 * Fire-and-forget call to record-presence edge function.
 * - In-memory dedupe per page load
 * - localStorage throttle (30 min)
 * - No-op if no session
 * - Errors swallowed
 */
export const recordPresence = async (): Promise<void> => {
  if (firedThisLoad) return;
  firedThisLoad = true;

  try {
    const last = Number(localStorage.getItem(STORAGE_KEY) || 0);
    if (last && Date.now() - last < THROTTLE_MS) return;
  } catch {
    // localStorage unavailable — proceed
  }

  try {
    const { data } = await supabase.auth.getSession();
    if (!data?.session) return;

    // fire-and-forget
    supabase.functions.invoke("record-presence").catch(() => {});

    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch {}
  } catch {
    // swallow
  }
};
